<app-header [brand]="brand"/>
<div
  class="flex justify-center"
  [ngClass]="{
  'mt-2': noMarginTop && !isDigSigWizard,
  '': noMarginTop && isDigSigWizard,
  'mt-4 lg:mt-16': !noMarginTop
  }"
>
  <div class="flex flex-col items-center">
    <div
      class="flex items-center justify-center gap-6 px-4 md:px-0"
      [ngClass]="{
      'lg:gap-6': noMarginTop && !isDigSigWizard,
      'lg:gap-2': noMarginTop && isDigSigWizard,
      'lg:gap-12': !noMarginTop
      }"
    >
      <img
        alt="Logo"
        src="/assets/images/{{brand.logo}}"
        class="object-scale-down p-1 w-[70px]"
        [ngClass]="{
        'lg:w-[90px]': noMarginTop && !isDigSigWizard,
        '': noMarginTop && isDigSigWizard,
        'lg:w-[100px]': !noMarginTop
        }"
      />
      <div>
        <div
          class="text-xl"
          [ngClass]="noMarginTop ? 'lg:text-2xl' : 'lg:text-3xl'"
        >
          {{ brand.brandName().toUpperCase() }} Einwilligungscenter
        </div>

        @if (userName) {
          <div
            class="w-full flex justify-end items-center mt-1 gap-1"
          >
            <img
              src="assets/icons/user.png"
              class="inline h-5 w-5 text-lighterText"
              [ngClass]="noMarginTop ? 'lg:w-6 lg:h-6' : 'lg:w-7 lg:h-7'"
            >
            <div
              class="text-sm text-lightText"
              [ngClass]="noMarginTop ? 'sm:text-base' : 'sm:text-lg'"
            >
              {{ userName }}
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
